import { createSlice, current } from '@reduxjs/toolkit';
import { v4 as uuid } from 'uuid';
//TODO be able to load this data from localstorage
//TODO be able to load this data from api

const jsonFields = ['inverter1Chosen', 'inverter2Chosen', 'panelChosen',
                    'monitoringChosen', 'monitoringConnectionChosen',
                    'batteryChosen'
                ];

const freshState = {
        allProducts: {
            loaded: false,
            data: {},
        },
        balanceMethod: "",
        batteryChosen: null,
        batteryChosenQty: 0,
        batteryOffered: false,
        chosenAddons: [],
        customerName: '',
        daytimeUsage: 40,
        dealID: null,
        depositAmount: 0,
        depositMethod: 'None',
        extraAddons1: {
            PipedriveID: 0,
            Description: null,
            SKU: null,
            Price: 0,
            Qty: 0,
        },
        extraAddons2: {
            PipedriveID: 0,
            Description: null,
            SKU: null,
            Price: 0,
            Qty: 0,
        },
        feedInTariff: 0.06,
        installRatePerPanel: 100,
        installYear: new Date().getFullYear(),
        inverter1Chosen: null,
        inverter1Qty: 1,
        inverter2Chosen: null,
        inverter2Qty: 0,
        isBatteryComm: false,
        isSelfGen: false,
        monitoringChosen: null,
        monitoringChosenQty: 0,
        monitoringConnectionChosen: null,
        monitoringConnectionChosenQty: 0,
        officeName: JSON.parse(localStorage.getItem("_dat") || '{}')?.officeName || 'Brisbane',
        panelChosen: null,
        panelChosenQty: 16,
        phases: "Single",
        powerPrice: 0.28,
        rackingChosen: null,
        rackingRoundedQty: 0,
        railChosen: null,
        railRoundedQty: 0,
        repName: "",
        roofType: '',
        saleDate: new Date().toLocaleDateString('en-CA'),
        salePrice: null,
        salesOOPE: 0,
        saleSubtotal: 0,
        saleType: "Solar",
        selectedBattery: "",
        selectedRebate1: [],
        selectedRebate1Qty: 0,
        selectedRebate2: [],
        selectedRebate2Qty: 0,
        selectedRebate3: [],
        selectedRebate3Qty: 0,
        siteBuildSystemSize: 0,
        spbCallCentre: 0,
        spbDD: 0,
        spbDeliveryAndM: 0,
        spbFloorCost: 0,
        spbHCode: 0,
        spbInstallation: 0,
        spbInverter: 0,
        spbLCode: 0,
        spbMargin: 0,
        spbMarketing: 0,
        spbModules: 0,
        spbOverheadTotal: 0,
        spbRacking: 0,
        spbShowHome: 0,
        spbSTC: 0,
        spbTotalEx: 0,
        spbTotalInc: 0,
        spbTrueCost: 0,
        stcRawQty: 0,
        stcTotalQuantity: 0,
        systemLossFactor: 0,
        systemSize: 9.96,
        taxRate: 37,
        test: null,
        twelveMonthIncrease: 40,
        uuid: uuid(),
        yearlyPowerBill: 3200,
        yearlyPriceIncrease: 10,
    }

export const formDataSlice = createSlice({
    name: 'formData',
    initialState: freshState,
    reducers: {
        setData: (state, action) => {
            if (jsonFields.indexOf(action.payload.prop) !== -1) {
                state[action.payload.prop] = JSON.parse(action.payload.value)
            } else {
                state[action.payload.prop] = action.payload.value;
            }

            // const reduxStore = store.getState();
            switch(action.payload.prop) {
                case 'officeName':
                    var saved = JSON.parse(localStorage.getItem('_dat') || "{}") ;
                    saved[action.payload.prop] = action.payload.value;
                    localStorage.setItem("_dat", JSON.stringify(saved));
                    break;
            }
        },
        setProducts: (state, action) => {
            state.allProducts.data = action.payload;
            state.allProducts.loaded = true;
        },
        resetProducts: (state, action) => {
            state.allProducts.data = {};
            state.allProducts.loaded = false;
        },
        resetStore: (state, action) => {
            state = freshState;
        }
    }
});

export default formDataSlice.reducer;

export const { setData, setProducts, resetProducts } = formDataSlice.actions

export const getFormData = (state) => state.formData;



